export default function LogOut() {
    sessionStorage.clear();
    window.location.replace(window.location.origin + window.location.pathname);
    return null;
}
